export function formatTaxYear(
  start: number,
  end: number,
  separator?: string,
): string {
  return `${start}${separator ?? '/'}${String(end).slice(-2)}`;
}
